export class BadRequestError extends Error {
  private data: any;

  constructor(message: string, data: object) {
    super(message);
    this.data = data;
  }

  getMessage() {
    return this.data.details ? this.data.details : null;
  }
}

export class ServerError extends Error {}

export class ExpiredTokenError extends Error {}

export class InvalidTokenError extends Error {}

export const handleError = (error: any) => {
  if (error.response) {
    if (error.response.status === 400) {
      throw new BadRequestError('BadRequestError', error.response.data);
    }
    if (error.response.status === 500) {
      throw new ServerError(error.response.data);
    }
  }

  throw error;
};
